<!-- Offers Management Header & Metric Cards -->
<div class="row mb-4">
  <div class="col-12 col-md-3 mb-2">
    <mat-card class="stat-card stat-total h-100">
      <mat-card-content class="d-flex align-items-center justify-content-between p-16">
        <div>
          <p class="stat-label mb-1">Total Offers</p>
          <h3 class="stat-number mb-0">{{ totalOffersCount }}</h3>
        </div>
        <div class="stat-icon-wrapper bg-primary-subtle text-primary">
          <mat-icon>local_offer</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-12 col-md-3 mb-2">
    <mat-card class="stat-card stat-active h-100">
      <mat-card-content class="d-flex align-items-center justify-content-between p-16">
        <div>
          <p class="stat-label mb-1">Active Offers</p>
          <h3 class="stat-number text-success mb-0">{{ activeOffersCount }}</h3>
        </div>
        <div class="stat-icon-wrapper bg-success-subtle text-success">
          <mat-icon>verified</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-12 col-md-3 mb-2">
    <mat-card class="stat-card stat-milestone h-100">
      <mat-card-content class="d-flex align-items-center justify-content-between p-16">
        <div>
          <p class="stat-label mb-1">Milestone Offers</p>
          <h3 class="stat-number text-info mb-0">{{ milestoneCount }}</h3>
        </div>
        <div class="stat-icon-wrapper bg-info-subtle text-info">
          <mat-icon>track_changes</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-12 col-md-3 mb-2">
    <mat-card class="stat-card stat-luckydraw h-100">
      <mat-card-content class="d-flex align-items-center justify-content-between p-16">
        <div>
          <p class="stat-label mb-1">Lucky Draws</p>
          <h3 class="stat-number text-warning mb-0">{{ luckyDrawCount }}</h3>
        </div>
        <div class="stat-icon-wrapper bg-warning-subtle text-warning">
          <mat-icon>card_giftcard</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Main Offer Card -->
<mat-card class="w-100 mb-4">
  <mat-card-content>
    <!-- Top Bar with Title and Add Button -->
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
      <div>
        <mat-card-title class="fs-20 fw-bold mb-1">Offer & Lucky Draw Management</mat-card-title>
        <mat-card-subtitle class="text-muted">Create, configure and monitor promotional milestone offers and lucky draws</mat-card-subtitle>
      </div>
      <button mat-raised-button color="primary" (click)="addOffer()" class="d-flex align-items-center gap-1">
        <mat-icon>add_circle_outline</mat-icon>
        <span>Add Offer</span>
      </button>
    </div>

    <!-- Filters Section -->
    <div class="filter-box mb-4 p-3 rounded bg-light">
      <div class="row g-2 align-items-center">
        <!-- Search by Name -->
        <div class="col-12 col-md-3">
          <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Search Offer Name</mat-label>
            <input matInput [formControl]="searchControl" placeholder="e.g. Mile Stone 1" (keyup.enter)="applyFilter()" />
            <mat-icon matPrefix class="me-2 text-muted">search</mat-icon>
          </mat-form-field>
        </div>

        <!-- Start Date -->
        <div class="col-12 col-md-2">
          <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" placeholder="Start Date" [formControl]="startDateControl" />
            <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- End Date -->
        <div class="col-12 col-md-2">
          <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" placeholder="End Date" [formControl]="endDateControl" />
            <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Status Filter -->
        <div class="col-12 col-md-2">
          <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Status</mat-label>
            <mat-select [formControl]="statusControl">
              <mat-option value="all">All Status</mat-option>
              <mat-option value="active">Active Only</mat-option>
              <mat-option value="inactive">Inactive Only</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Offer Type Filter -->
        <div class="col-12 col-md-3">
          <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Offer Type</mat-label>
            <mat-select [formControl]="typeControl">
              <mat-option value="all">All Types</mat-option>
              <mat-option value="milestone">Milestone Offers</mat-option>
              <mat-option value="luckyDraw">Lucky Draws</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Filter Buttons -->
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button mat-stroked-button color="warn" (click)="clearFilters()" *ngIf="hasActiveFilters()">
          <mat-icon>clear</mat-icon> Clear Filters
        </button>
        <button mat-raised-button color="primary" (click)="applyFilter()">
          <mat-icon>filter_list</mat-icon> Apply Filters
        </button>
      </div>
    </div>

    <!-- Spinner Loading -->
    <div class="spinner py-5" *ngIf="spinner">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Table Section -->
    <div [hidden]="spinner" class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="text-nowrap w-100" matSort>
        <!-- Order Column -->
        <ng-container matColumnDef="order">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center" style="width: 70px;">Order</th>
          <td mat-cell *matCellDef="let element" class="text-center py-2">
            <span class="order-badge fw-bold text-primary">#{{ element.sortOrder ?? 0 }}</span>
          </td>
        </ng-container>

        <!-- Image Column -->
        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 80px;">Banner</th>
          <td mat-cell *matCellDef="let element" class="text-center py-2">
            <div *ngIf="element.imageUrl" class="banner-preview-box">
              <img [src]="environmentURL + '/' + element.imageUrl" alt="Offer Banner" class="offer-thumb rounded shadow-sm" />
            </div>
            <div *ngIf="!element.imageUrl" class="banner-placeholder-box rounded">
              <mat-icon class="text-muted">image</mat-icon>
            </div>
          </td>
        </ng-container>

        <!-- Offer Name & Description Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Offer Details</th>
          <td mat-cell *matCellDef="let element" class="py-2">
            <div class="d-flex flex-column">
              <span class="fw-bold fs-15 text-dark">{{ element.name }}</span>
              <small class="text-muted text-truncate" style="max-width: 260px;" *ngIf="element.description">
                {{ element.description }}
              </small>
              <small class="text-secondary mt-1" *ngIf="element.rules && element.rules.length > 0">
                <mat-icon class="inline-icon text-muted me-1">gavel</mat-icon>
                {{ element.rules.length }} Rule{{ element.rules.length > 1 ? 's' : '' }} configured
              </small>
            </div>
          </td>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
          <td mat-cell *matCellDef="let element" class="py-2">
            <span *ngIf="element.isLuckyDraw" class="type-badge badge-luckydraw">
              <mat-icon class="badge-icon me-1">card_giftcard</mat-icon> Lucky Draw
            </span>
            <span *ngIf="!element.isLuckyDraw" class="type-badge badge-milestone">
              <mat-icon class="badge-icon me-1">track_changes</mat-icon> Milestone
            </span>
          </td>
        </ng-container>

        <!-- Validity / Duration Column -->
        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Validity Period</th>
          <td mat-cell *matCellDef="let element" class="py-2">
            <div class="d-flex flex-column">
              <span class="fs-13 fw-medium">
                {{ element.startDate | date : 'dd MMM yyyy' }} &rarr; {{ element.endDate | date : 'dd MMM yyyy' }}
              </span>
              <span [ngClass]="getOfferStatusLabel(element).class" class="status-pill mt-1">
                {{ getOfferStatusLabel(element).label }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Total Target Quantity Column -->
        <ng-container matColumnDef="totalQty">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Target Qty</th>
          <td mat-cell *matCellDef="let element" class="text-center py-2">
            <span class="qty-badge fw-bold">
              {{ element.totalQty }} pcs
            </span>
          </td>
        </ng-container>

        <!-- Category Breakdown / Requirements Column -->
        <ng-container matColumnDef="targets">
          <th mat-header-cell *matHeaderCellDef style="min-width: 220px;">Category Targets</th>
          <td mat-cell *matCellDef="let element" class="py-2">
            <div *ngIf="element.isLuckyDraw" class="text-muted fst-italic fs-13">
              <span>Overall draw entry &bull; Min {{ element.totalQty }} scans</span>
            </div>
            <div *ngIf="!element.isLuckyDraw" class="target-chips-container d-flex flex-wrap gap-1">
              <ng-container *ngFor="let cat of element.categories">
                <span *ngIf="!cat.isCombined" class="cat-chip">
                  <span class="chip-name">{{ cat.categoryNames?.join(', ') || 'Category' }}:</span>
                  <strong class="chip-qty ms-1">{{ cat.qty }}</strong>
                </span>
                <span *ngIf="cat.isCombined" class="cat-chip chip-combined">
                  <mat-icon class="chip-icon me-1">join_inner</mat-icon>
                  <span class="chip-name">{{ cat.groupName || (cat.categoryNames?.join(' + ')) }}:</span>
                  <strong class="chip-qty ms-1">{{ cat.qty }}</strong>
                </span>
              </ng-container>
              <span *ngIf="!element.categories || element.categories.length === 0" class="text-muted fs-13">
                No specific category targets
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
          <td mat-cell *matCellDef="let element" class="text-center py-2">
            <mat-slide-toggle
              color="primary"
              [checked]="element.isActive"
              (change)="onToggleStatus(element)"
              [matTooltip]="element.isActive ? 'Active - Click to Deactivate' : 'Inactive - Click to Activate'">
            </mat-slide-toggle>
          </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 110px;">Actions</th>
          <td mat-cell *matCellDef="let element" class="text-center py-2">
            <button mat-icon-button color="primary" aria-label="Edit Offer" (click)="onEdit(element._id)" matTooltip="Edit Offer">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" aria-label="Delete Offer" (click)="onDelete(element._id)" matTooltip="Delete Offer">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- No data matching filter row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center py-4" [attr.colspan]="displayedColumns.length">
            <div class="empty-state py-4">
              <mat-icon class="empty-icon text-muted mb-2">sentiment_dissatisfied</mat-icon>
              <h5 class="text-muted mb-1">No Offers Found</h5>
              <p class="text-muted fs-13 mb-3">No offers match the selected filters or none have been created yet.</p>
              <button mat-flat-button color="primary" (click)="addOffer()">
                <mat-icon>add</mat-icon> Create First Offer
              </button>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- Paginator -->
    <mat-paginator
      #paginator
      [pageSizeOptions]="[10, 20, 50, 100]"
      showFirstLastButtons
      aria-label="Select page of offers">
    </mat-paginator>
  </mat-card-content>
</mat-card>
